import { MilestonesCard } from '@/components/MilestonesCard';
import { RisksLogCard } from '@/components/RisksLogCard';
import { useRoomContext } from './context';

/** The room's risks & issues log and its timeline milestones (ADR-0047) — what
 * the weekly digest reports alongside the checklist. Read-only once the room is
 * archived (the API refuses writes there too). */
export function RoomRisksPage() {
  const { roomId, room } = useRoomContext();
  const readOnly = room.lifecycleState !== 'active';
  return (
    <div className="max-w-4xl space-y-6">
      <RisksLogCard roomId={roomId} readOnly={readOnly} />
      <MilestonesCard roomId={roomId} readOnly={readOnly} />
    </div>
  );
}
